import { call, put, takeEvery } from "redux-saga/effects";
import { fetchPlanDetails } from "../../api/planApi";
import { PLANS_CONSTANTS } from "../constants/planConstants";


function* fetchPlanDetailsSaga(action) {
  try {
    const response = yield call(fetchPlanDetails, action.payload);
    yield put({ type: PLANS_CONSTANTS.FETCH_PLAN_DETAILS_SUCCESS, payload: response.response });
  } catch (error) {
    yield put({ type: PLANS_CONSTANTS.FETCH_PLAN_DETAILS_FAILURE, payload: error.message });
  }
}

function* planSaga() {
  yield takeEvery(PLANS_CONSTANTS.FETCH_PLAN_DETAILS_REQUEST, fetchPlanDetailsSaga);
}

export default planSaga;